import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import LoadingSpinner from './LoadingSpinner';

const AdminRoute = ({ children }) => {
  const { admin, isAuthenticated, isLoading, checkAdminStatus } = useAdminAuth();
  const location = useLocation();

  // Trigger admin status check when accessing admin routes
  useEffect(() => {
    checkAdminStatus();
  }, [checkAdminStatus]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated || !admin) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }
  return children;
};

export default AdminRoute;